/**
 * 模組頁面代碼 : 1420-UI-01
 * 頁面說明 : 機器資料頁面
 * @module modules/machine/components/MachinePage
 */

// ----- import from npm modules -----
import React from 'react';
import $ from 'jquery';
// ----- import from base libraries -----

import {useEffect, useState, useRef} from 'react';
import {showMessage} from 'web/utils/modalHelper';
import {BaseComponent} from 'web/components/BaseComponent';
import enumList from 'web/utils/enumList';
import {useDispatch} from 'react-redux';
import {useMachine} from '../hooks/useMachine';

const MachinePage = (props) => {
  const dispatch = useDispatch();
  const currentSectionRef = useRef(null);
  const baseComponent = new BaseComponent(props);
  const {
    onBatchHandle,
    needMachineLoad,
    toggleMachineAddModal,
    toggleMachineEditModal,
    toggleMachineBindingHistoryModal,
    setNeedMachineLoad,
    setMachineID,
    checkedMachineIds,
    setCheckedMachineIds,
  } = props;
  const [searchMachineType, setSearchMachineType] = useState('');
  const [searchDeliveryCode, setSearchDeliveryCode] = useState('');
  const [searchMachineSerialNumber, setSearchMachineSerialNumber] =
    useState('');
  const tableRef = useRef(null);

  const {machineList, setSearchParams} = useMachine(
    dispatch,
    showMessage,
    baseComponent,
    checkedMachineIds,
    setCheckedMachineIds,
  );

  useEffect(() => {
    baseComponent.checkPermission(
      enumList.moduleEnums.customer,
      enumList.accessModeEnums.read,
    );
    setSearchParams({
      searchMachineType,
      searchDeliveryCode,
      searchMachineSerialNumber,
    });
    setNeedMachineLoad(false);
  }, [needMachineLoad]);

  useEffect(() => {
    if (machineList.length) {
      const checkboxs = $('.item-cks-customer');
      for (const checkbox of checkboxs) {
        const idx = checkbox.id.split('-')[2];
        if (!checkedMachineIds.length) {
          checkbox.checked = false;
          $('#check-all').prop('checked', false);
        }
        if (checkedMachineIds.includes(machineList[idx].machineId)) {
          checkbox.checked = true;
        }
      }
    }
    const handleClick = (event) => {
      const button = event.target.closest('.machine-edit-btn');
      if (button && button.id.startsWith('edit-customer-')) {
        toggleMachineEditModal(
          true,
          machineList[parseInt(button.id.split('-')[2])],
        );
      }
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-customer-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked
          ? enumList.alertModalModeEnums.enable
          : enumList.alertModalModeEnums.disable;
        const updateMachine = machineList[index];
        if (updateMachine) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updateMachine.customerName} ] 的資料`;
          } else {
            message = `停用 [ ${updateMachine.customerName} ] 的資料`;
          }
          onBatchHandle(mode, message, [updateMachine.customerCode]);
        } else {
          console.log('No case found at index:', index);
        }
      }

      if (checkbox && checkbox.classList.contains('item-cks-customer')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const id = machineList[index].machineId;
        if (checkedMachineIds.includes(id)) {
          setCheckedMachineIds(checkedMachineIds.filter((item) => item !== id));
          checkbox.checked = false;
        } else {
          setCheckedMachineIds([...checkedMachineIds, id]);
        }
      }

      if (checkbox && checkbox.id === 'check-all') {
        const ids = machineList.map((item) => item.machineId);
        if (checkbox.checked) {
          setCheckedMachineIds([...new Set([...checkedMachineIds, ...ids])]);
        } else {
          setCheckedMachineIds(
            checkedMachineIds.filter((item) => !ids.includes(item)),
          );
        }
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [machineList, checkedMachineIds]);

  useEffect(() => {
    const handleClick = (event) => {
      const button = event.target.closest('.show-machine-binding-history-btn');
      if (button && button.id.startsWith('show-machine-binding-history-')) {
        if (!(machineList?.length > 0)) {
          return;
        }
        setMachineID(
          machineList[parseInt(button.id.match(/\d+$/)[0])].machineId,
        );
        toggleMachineBindingHistoryModal();
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }
    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [machineList]);

  useEffect(() => {
    /**
     * @param {Event} e
     */
    const listener = (e) => {
      if (
        !(
          e.target.classList.contains('enable-switch') &&
          e.target.classList.contains('machine-status-switch')
        )
      ) {
        return;
      }
      const flgStatus =
        enumList.alertModalModeEnums[e.target.checked ? 'enable' : 'disable'];
      const {id} = e.target.dataset;
      onBatchHandle(
        flgStatus,
        `${e.target.checked ? '啟用' : '停用'} [ ${id} ]`,
        [Number(id)],
      );
    };

    if (currentSectionRef?.current) {
      currentSectionRef.current.addEventListener('change', listener);
    }
    return () => {
      if (currentSectionRef?.current) {
        currentSectionRef.current.removeEventListener('change', listener);
      }
    };
  }, [machineList]);

  const handleSearch = (e) => {
    e.preventDefault();
    const searchForm = new FormData(e.target);

    setSearchParams({
      deliveryCode: searchForm.get('searchDeliveryCode'),
      machineSerialNumber: searchForm.get('searchMachineSerialNumber'),
      machineTypeId: searchForm.get('searchMachineType'),
    });
  };

  return (
    <section id="datatable-container" ref={currentSectionRef}>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg
              className="nav__icon nav__icon--breadcrumb me-3"
              aria-hidden="true"
            >
              <use href="#ico-home-line"></use>
            </svg>
            基本資料
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            機器資料
          </li>
        </ol>
      </nav>
      <h4>機器資料</h4>
      <div className="datatable__search">
        <form
          className="d-flex gap-2 align-items-end needs-validation"
          noValidate
          onSubmit={handleSearch}
        >
          <div className="flex-fill w-100">
            <label htmlFor="searchDeliveryCode" className="form-label">
              交機編號
            </label>
            <input
              className="form-control form-control-sm"
              id="searchDeliveryCode"
              name="searchDeliveryCode"
              value={searchDeliveryCode}
              onChange={(e) => setSearchDeliveryCode(e.target.value)}
              required
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchMachineSerialNumber" className="form-label">
              機械番號
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="searchMachineSerialNumber"
              name="searchMachineSerialNumber"
              value={searchMachineSerialNumber}
              onChange={(e) => setSearchMachineSerialNumber(e.target.value)}
              required
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchMachineType" className="form-label">
              機器種類
            </label>
            <select
              className="form-select form-select-sm"
              id="searchMachineType"
              name="searchMachineType"
              onChange={(e) => setSearchMachineType(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              {Object.entries(enumList.machineTypes).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <button className="btn btn-primary" type="submit">
              <svg className="btn__icon" aria-hidden="true">
                <use href="#ico-search"></use>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div className="datatable__tool">
        <div className="d-flex align-items-center gap-2">
          <div className="datatable__tool__label">
            多筆選擇
            <div>{checkedMachineIds.length}</div>
          </div>
          {baseComponent.checkPermission(
            enumList.moduleEnums.customer,
            enumList.accessModeEnums.delete,
          ) && (
            <div className="btn-group btn-group-sm" role="group" aria-label="">
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchEnable"
                disabled={checkedMachineIds.length === 0}
                onClick={() =>
                  onBatchHandle(
                    enumList.alertModalModeEnums.enable,
                    '',
                    checkedMachineIds,
                    true,
                  )
                }
              >
                啟用
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchDisable"
                disabled={checkedMachineIds.length === 0}
                onClick={() =>
                  onBatchHandle(
                    enumList.alertModalModeEnums.disable,
                    '',
                    checkedMachineIds,
                    true,
                  )
                }
              >
                停用
              </button>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          {baseComponent.checkPermission(
            enumList.moduleEnums.customer,
            enumList.accessModeEnums.create,
          ) && (
            <button
              type="button"
              className="btn btn-sm btn-primary"
              id="modalElevatorBtnNew"
              onClick={toggleMachineAddModal}
            >
              <svg className="btn__icon me-2" aria-hidden="true">
                <use href="#ico-plus-square"></use>
              </svg>
              新增
            </button>
          )}
        </div>
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table
          id="datatable__machineList"
          className="display table table-hover align-middle nowrap"
        ></table>
      </div>
    </section>
  );
};

export default MachinePage;
